import AbstractApiModel from '@/models/abstracts/AbstractApiModel';

/** POST {email} : e-mail avec un lien de réinitialisation (réponse identique que le compte existe ou non) */
export default class PasswordResetRequestModel extends AbstractApiModel {
  protected _path = '/password_reset_requests';
}
